// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client'; // Korrigierter Importpfad
import App from './App';
import { AuthProvider } from './contexts/AuthContext';

// Stelle sicher, dass das Root-Element existiert
const container = document.getElementById('root');
if (!container) {
  throw new Error("Das Root-Element mit der ID 'root' wurde nicht gefunden.");
}

// Erstelle den Root und rendere die Anwendung
const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
